import byTypename from "./byTypename";

export default function filterUnionByTypename<
  Type extends { __typename: string },
  Value extends string & Type["__typename"],
>(union: Type[], lookingFor: Value) {
  return union.filter(byTypename(lookingFor));
}
